import { render, staticRenderFns } from "./ExclusionAlert.vue?vue&type=template&id=3dfd0303"
import script from "./ExclusionAlert.vue?vue&type=script&lang=js"
export * from "./ExclusionAlert.vue?vue&type=script&lang=js"
import style0 from "./ExclusionAlert.vue?vue&type=style&index=0&id=3dfd0303&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports